<div *ngIf="commits.length === 0" class="h-full w-full aligner flex-col">
  <img src="assets/images/not-available/no-filter-result.svg" alt="" width="40" class="mb-1" />
  No Search Results
</div>
<cdk-virtual-scroll-viewport
  itemSize="55"
  class="commits-container"
  (scrolledIndexChange)="onScrolledIndexChanged()"
  [hidden]="commits.length === 0"
>
  <button
    mat-menu-item
    *cdkVirtualFor="let commit of commits; trackBy: trackByFn; let i = index"
    class="p-2 border-b cursor-pointer commit flex flex-col justify-center"
    [class.bg-primary-100]="active === commit"
    [attr.data-i]="i"
    (click)="activeChange.emit(commit)"
  >
    <y42-git-commit-item class="block w-full" [commit]="commit"></y42-git-commit-item>
  </button>
</cdk-virtual-scroll-viewport>
